import script from "./ProductCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductCard.vue?vue&type=script&lang=ts&setup=true"

import "./ProductCard.vue?vue&type=style&index=0&id=71b66b76&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71b66b76"]])

export default __exports__